import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Globals } from "app/main/module/common/global";
import { StorageService } from "app/main/module/common/service/storage.service";
import { TicketsService } from "../tickets.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TicketDataService } from "../ticket-data.service";
import { Tickets } from "../tickets";
import { ApiService } from "app/main/module/common/service/api.service";
import { AttachmentDialogComponent } from "../attachment-dialog/attachment-dialog.component";
import { fuseAnimations } from "@fuse/animations";
import { CommentsDialogComponent } from "../comments-dialog/comments-dialog.component";
import { SignatureDialogComponent } from "../signature-dialog/signature-dialog.component";

@Component({
    selector: "app-ticket-details",
    templateUrl: "./ticket-details.component.html",
    styleUrls: ["./ticket-details.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class TicketDetailsComponent implements OnInit {
    ticketData: any;
    isLoading: Boolean = false;
    hasFirstDataShown: Boolean = false;
    previewUrls: { url: string; isNew: boolean; file?: File; type?: string }[] =
        [];
    constructor(
        private route: ActivatedRoute,
        private userService: StorageService,
        private router: Router,
        public translate: TranslateService,
        public dialog: MatDialog,
        public global: Globals,
        public ticketService: TicketsService,
        public snackbar: MatSnackBar,
        public ticketDataService: TicketDataService,
        private apiService: ApiService
    ) {}

    ngOnInit(): void {
        const ticketId = this.route.snapshot.queryParamMap.get("ticket_id");
        const cached = this.ticketDataService.getTicket(ticketId!);

        if (cached) {
            this.ticketData = cached;
            // console.log(this.ticketData);
        } else {
            this.getSingleTicket(ticketId);
        }
    }

    getSingleTicket(id): void {
        this.isLoading = true
        this.ticketService.getSingleTicket(id).subscribe(
            (response: any) => {
                if (response && response.data) {
                    this.ticketData = response.data[0];

                    
                    // console.log(this.ticketData);
                    this.hasFirstDataShown = false;
                    this.isLoading = false;
                }
            },
            (error) => {
                let errorMessage = error.error.message;
                this.openSnackBar(
                    errorMessage,
                    this.translateSentence("Common.ok")
                );
                console.error("Error fetching cases:", error);
            }
        );
    }

    changeDate(date): any {
        // // // console.log(e);
        var timestamp = parseInt(date);
        return (date = this.apiService.getDateStringMomentByTz(timestamp));
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    openSnackBar(message: string, action: string): void {
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }

    openAttachmentDialog(row): void {
        if (row && row?.upload_file) {
            this.previewUrls = row?.upload_file.map(
                (url: string) => ({
                    url: url,
                    isNew: false,
                    type: this.getFileType(url),
                })
            );
        }
        const dialogRef = this.dialog.open(AttachmentDialogComponent, {
            disableClose: true,
            width: "525px",
            data: { upload_file: this.previewUrls },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    openCommentDialog(row): void {
        const dialogRef = this.dialog.open(CommentsDialogComponent, {
            disableClose: true,
            width: "525px",
            data: { comments: row.comments },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    openSignatureDialog(row): void {
        const dialogRef = this.dialog.open(SignatureDialogComponent, {
            disableClose: true,
            width: "525px",
            data: { signature: row.signature },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    getFileType(url: string): "image" | "video" {
        const ext = url.split(".").pop()?.toLowerCase();

        if (!ext) return "image";

        const imageExts = ["jpg", "jpeg", "png", "gif", "webp"];
        const videoExts = ["mp4", "mov", "avi", "mkv", "webm"];

        if (imageExts.includes(ext)) return "image";
        if (videoExts.includes(ext)) return "video";

        return "image";
    }

    capitalizeFirstLetter(word: string): string {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
}
